import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MegaMenuConfig } from '../../models/mega-menu.model';

@Component({
  selector: 'app-mega-menu',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './mega-menu.component.html',
  styleUrl: './mega-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'class': 'absolute top-[100%] left-0 w-full bg-white z-50 h-[274px] px-[30px] md:px-[60px] flex items-center justify-between select-none block shadow-lg border-b border-gray-100',
    '[class.animate-fade-in-down]': '!isClosing',
    '[class.animate-fade-out]': 'isClosing',
  }
})
export class MegaMenuComponent {
  @Input() config!: MegaMenuConfig;
  @Input() isClosing = false;
  @Output() closeMenu = new EventEmitter<void>();
  readonly activeColumn = signal(0);

  get isStoreMenu(): boolean {
    return this.config.mainUrl === '/store';
  }

  selectColumn(index: number): void {
    this.activeColumn.set(index);
  }

  onLinkClick(): void {
    this.closeMenu.emit();
  }
}
